import '../assets/NcCheckboxRadioSwitch-CFKCb80n.css';
import { r as register } from "./_l10n-B6zipH_A.mjs";
register();
